import React from 'react'

const LinkedInIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props?.size ?? 16} height={props?.size ?? 16} viewBox="0 0 16 16" fill="none">
            <path d="M14.638 9.1469V14.0662H11.786V9.47623C11.786 8.3229 11.3734 7.53623 10.3414 7.53623C9.55336 7.53623 9.08403 8.0669 8.87803 8.57956C8.8027 8.7629 8.78336 9.01823 8.78336 9.2749V14.0662H5.93003C5.93003 14.0662 5.9687 6.2929 5.93003 5.4869H8.78336V6.7029L8.7647 6.7309H8.78336V6.7029C9.16203 6.11956 9.8387 5.28556 11.354 5.28556C13.2307 5.28556 14.638 6.51223 14.638 9.1469ZM2.94603 1.35156C1.9707 1.35156 1.33203 1.99156 1.33203 2.83356C1.33203 3.6569 1.95203 4.31623 2.9087 4.31623H2.92736C3.9227 4.31623 4.5407 3.6569 4.5407 2.83356C4.52336 1.99156 3.9227 1.35156 2.94603 1.35156ZM1.50136 14.0662H4.35336V5.4869H1.50136V14.0662Z" fill={props?.color ?? '#404040'} />
        </svg>
    )
}

export default LinkedInIcon